// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home{
    position: relative;
    bottom: 300px;
    right: 100px;
}
.Restaurant-menus-container {
    display: flex;
    justify-content: flex-start;
}

.Restaurant-menus {
    /* Remove the width property to allow the container to expand */
    display: flex;
    flex-direction: row;
}

.Menu-list {
    display: flex;
}

.Menu-item {
width: 300px;
    margin-right: 10px;
}`, "",{"version":3,"sources":["webpack://./client/features/user.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,aAAa;IACb,YAAY;AAChB;AACA;IACI,aAAa;IACb,2BAA2B;AAC/B;;AAEA;IACI,+DAA+D;IAC/D,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;AACA,YAAY;IACR,kBAAkB;AACtB","sourcesContent":[".home{\r\n    position: relative;\r\n    bottom: 300px;\r\n    right: 100px;\r\n}\r\n.Restaurant-menus-container {\r\n    display: flex;\r\n    justify-content: flex-start;\r\n}\r\n\r\n.Restaurant-menus {\r\n    /* Remove the width property to allow the container to expand */\r\n    display: flex;\r\n    flex-direction: row;\r\n}\r\n\r\n.Menu-list {\r\n    display: flex;\r\n}\r\n\r\n.Menu-item {\r\nwidth: 300px;\r\n    margin-right: 10px;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
